/**
 * 工具模块
 */
import 'vant/lib/toast/style/index';

import buildUtil from 'build-util';
import Toast from 'vant/lib/toast/index';
import Cookies from 'js-cookie';
import MJSSDK from '@mfex/mjssdk';
import constant from './constant';

export function getAssetImg(name: string) {
    return buildUtil.assetsURL(`img/${name}`);
}

export function padStart(str: number | string, len = 2, pad = '0') {
    return String(str).padStart(len, pad);
}
/**
 * 格式化时间时分秒
 * @param time 时间秒
 * @returns 格式化后的时间 hh:mm:ss
 */
export function formatVideoTime(time: number) {
    const h = Math.floor(time / 3600);
    const m = Math.floor((time % 3600) / 60);
    const s = Math.floor(time % 60);
    return `${h > 0 ? `${padStart(h)}:` : ''}${m > 0 ? `${padStart(m)}:` : '00:'}${padStart(s)}`;
}

export const url = new URL(window.location.href);

export function getQueryString(name: string) {
    return url.searchParams.get(name);
}

export function formatDate(time: string) {
    // eslint-disable-next-line @mfex/no-date-usage
    const date = new Date(time);
    // const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const hour = date.getHours();
    const minute = date.getMinutes();
    // const second = date.getSeconds();
    return `${padStart(month)}-${padStart(day)} ${padStart(hour)}:${padStart(minute)}`;
}

export const loading = {
    show() {
        Toast.loading({
            message: '加载中...'
        });
    },
    clear() {
        Toast.clear();
    }
};

export const setPageTitle = (title: string) => {
    document.title = title;
};

export function goto(link: string) {
    window.location.href = link;
}

export function genRandomStr(length: number): string {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
}

export function getScrollTop(el: HTMLElement) {
    if (!el) {
        return;
    }
    return el.scrollTop;
}

export function scrollToTop(el: HTMLElement, top = 0, left = 0) {
    if (!el) {
        return;
    }
    el.scrollTo(top, left);
}

// 业务 ===========
/**
 * 生成随机id, 约定格式`MW123456`
 * @returns {string}
 */
export function genRandomUid() {
    const uid = `MW${genRandomStr(6)}`;
    window.localStorage.setItem(constant.STORAGE_KEY.PT_LIVE_ID, uid);
    return uid;
}
/**
 * 尝试从 cookie、localStorage中获取id，若无则生成
 * @returns {string}
 */
export function getUidAndNick(): {uid: string; nick: string} {
    const cookieUid = Cookies.get('user_id');
    if (cookieUid) {
        return {
            uid: cookieUid,
            nick: cookieUid
        };
    }
    const genUid = window.localStorage.getItem(constant.STORAGE_KEY.PT_LIVE_ID) || genRandomUid();
    return {
        uid: genUid,
        nick: `游客_${genUid}`
    };
}

export const liveId = getQueryString('live_id');

export const appLiveDetailLink = `mmw://live_detail?android_path=/streaming/liveDetail&ios_path=PHMMLive/liveDetailsWithLiveID:&liveId=${liveId}&liveID=${liveId}`;

export function download() {
    window.location.href = `https://app.mama.cn/soft_link/pt?type=888&url=${encodeURIComponent(appLiveDetailLink)}`;
}

export function formatLikeNum(numStr: string) {
    const num = parseFloat(numStr);
    if (num > 10000) {
        return `${(num / 10000).toFixed(1)}万`;
    }
    return num;
}

export function checkPregnancyApp() {
    if (MJSSDK.UA.pregnancyhelper) {
        window.location.href = appLiveDetailLink;
    }
}
